const handleDeleteFrequencyFormParamFreq = {
  confirm: '¿Realmente quiere eliminar el elemento?',
  title: 'ELIMINAR ELEMENTO'
};

export default handleDeleteFrequencyFormParamFreq;
